export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7808.972ac712.jpg";